export default "__VITE_PUBLIC_ASSET__f7c6bf49__"